import { _defineProperty } from "./index13.js";
var PerfStopwatch = class {
	constructor() {
		_defineProperty(this, "resumed", true);
		_defineProperty(this, "from", performance.now());
		_defineProperty(this, "_elapsed", 0);
	}
	get elapsed() {
		return this._elapsed;
	}
	pause() {
		this._elapsed += performance.now() - this.from;
		this.resumed = false;
	}
	resume() {
		if (this.resumed) return;
		this.resumed = true;
		this.from = performance.now();
	}
};
export { PerfStopwatch };

//# sourceMappingURL=index14.js.map